import { MediaQuery } from '@maxpreps/shared/styles/breakpoint';
import THEME from '@maxpreps/shared/styles/colors';
import { teamCheckboxPadding, teamPencilPadding } from '../../utils/teamStyles';

const COLS = {
  checkbox: `
    ${teamCheckboxPadding}
  `,
  dateTime: `
    text-align: left;
    padding-right: 0;
    ${MediaQuery.Tablet} {
      padding-right: 16px;
    }
  `,
  mascot: `
    padding: 16px 8px;
  `,
  main: `
    width: 100%;
    position: relative;
    text-align: left;
  `,
  results: `
    padding-left: 8px;
    text-align: right;
  `,
  edit: `
    border-left: 1px solid ${THEME.general.border};
    ${teamPencilPadding}
  `
};

const scheduleTableConfig = {
  layout: 'table1',
  table: {
    isPadded: true
  },
  rowStyles: {
    body: {
      last: `
        & > :first-child {
          border-bottom-left-radius: 12px;
        }
        & > :last-child {
          border-bottom-right-radius: 12px;
        }
      `
    }
  },
  columnStyles: {
    // Override default desktop y padding
    allBody: `
      vertical-align: top;
      ${MediaQuery.Tablet} {
        padding-top: 16px;
        padding-bottom: 16px;
      }
    `,
    body: undefined as any
  }
};

export const getTableConfig = (isAdmin, isMobile) => {
  const configCopy = { ...scheduleTableConfig };
  configCopy.columnStyles = { ...scheduleTableConfig.columnStyles };
  if (isAdmin) {
    if (isMobile) {
      configCopy.columnStyles.body = [
        COLS.dateTime,
        COLS.main,
        COLS.results,
        COLS.edit
      ];
    } else {
      configCopy.columnStyles.body = [
        COLS.checkbox,
        COLS.dateTime,
        COLS.mascot,
        COLS.main,
        COLS.results,
        COLS.edit
      ];
    }
  } else if (isMobile) {
    configCopy.columnStyles.body = [COLS.dateTime, COLS.main, COLS.results];
  } else {
    configCopy.columnStyles.body = [
      COLS.dateTime,
      COLS.mascot,
      COLS.main,
      COLS.results
    ];
  }
  return configCopy;
};
